import { Injectable } from '@angular/core';
import * as contentful from 'contentful';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import { Entry } from 'contentful';

@Injectable()
export class ContentfulService {

  private client = contentful.createClient({
    space: environment.contentful.spaceId,
    accessToken: environment.contentful.token

  })



  constructor() { }

  // console logs a response for debugging
  logContent(contentId) {
     this.client.getEntry(contentId)
      .then(entry => console.log(entry) )
  }
  // retrieves content mapped to its data fields
  getContent(contentId) {
    const promise = this.client.getEntry(contentId)
    return Observable.fromPromise(promise).map(entry => entry.fields)
  }


  getProducts(query?: object): Promise<Entry<any>[]> {
    return this.client.getEntries(Object.assign({
      content_type: environment.contentful.contentTypeIds.product
    }, query))
    .then(res => res.items);
  }

    // fetch categories
    getCategories(): Promise<Entry<any>[]> {
      return this.client.getEntries({
        content_type: environment.contentful.contentTypeIds.category
      })
      .then(res => res.items);
    }

    getProductsByCategory(categoryId: string){
      return this.client.getEntries({content_type: environment.contentful.contentTypeIds.product,
        'fields.categories.sys.id': categoryId})
        .then(res => res.items);
    }


}







// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/contentful.service.ts